import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { buildWhatsAppLink, getContact } from "@/lib/site";
import { useContent } from "@/lib/content";

export default function FloatingButtons() {
  const { content } = useContent();
  const c = getContact(content);
  const waText = `Hi Educators Institute, I'd like to know more about your courses and book a free career consultation.`;
  return (
    <div className="fixed bottom-5 right-5 z-[100] flex flex-col gap-3 items-end">
      <a
        href={`tel:${c.phoneRaw}`}
        data-testid="floating-call-btn"
        aria-label="Call us"
        className="group relative w-14 h-14 rounded-full bg-[#002570] text-white flex items-center justify-center shadow-[0_8px_30px_rgba(0,37,112,0.35)] hover:scale-110 transition-transform"
      >
        <Phone className="w-5 h-5" />
        <span className="hidden md:inline-block absolute right-16 top-1/2 -translate-y-1/2 whitespace-nowrap bg-[#002570] text-white text-xs font-medium px-3 py-1.5 rounded-full opacity-0 group-hover:opacity-100 transition-opacity">
          Call Now
        </span>
      </a>
      <a
        href={buildWhatsAppLink(waText, c.whatsappRaw)}
        target="_blank"
        rel="noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="WhatsApp us"
        className="wa-pulse relative w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
    </div>
  );
}
